import React, { useContext, useEffect, useState } from 'react';
import { graphql } from 'gatsby';
import styled from '@emotion/styled';

import Layout from '../../components/Layout';
import SEO from '../../components/seo';

const Body = styled.div`
  h1,
  h2,
  h3,
  p,
  ul,
  ol {
    margin-bottom: 24px;
  }
  h1 {
    font-size: 24px;
    line-height: 1.5;
    font-family: Comfortaa;
    font-style: normal;
    font-weight: bold;
  }
  h2 {
    font-family: Roboto;
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 8px;
  }

  ul {
    list-style: disc;
    margin-left: 16px;
  }
  ol {
    list-style: decimal;
    margin-left: 24px;
  }
`;

const TextPage = ({ data }) => {
  const { title, body } = data.shopifyPage;

  return (
    <Layout>
      <SEO keywords={[`bluli`, `blue-light`, `screen-protectors`, `e-commerce`]} title={title} />
      <div className="relative w-full xl:container px-4 sm:px-8 mx-auto py-24 md:py-64">
        <Body className="max-w-4xl" dangerouslySetInnerHTML={{ __html: body }} />
      </div>
    </Layout>
  );
};

export const query = graphql`
  query($handle: String!) {
    shopifyPage(handle: { eq: $handle }) {
      body
      title
      handle
    }
  }
`;

export default TextPage;
